import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FeaturedProjects = () => {
  const projects = [
    {
      id: 0,
      title: "KiviCare MediFlow",
      description: "A comprehensive, white-label clinic management platform with native dental charting, dual telemedicine support, and multi-currency billing.",
      image: "/assets/images/kivcare_mern.png",
      technologies: ["Next.js", "Node.js", "Express", "MongoDB", "Socket.io", "React Query", "TailwindCSS", "Zustand", "Stripe", "Zoom API", "Twilio"],
      liveUrl: "https://mediflow.titanscale.net",
      githubUrl: "",
      featured: true
    },
    {
      id: 2,
      title: "NuxHealth (HMS) (Backend Development)",
      description: "A comprehensive hospital management system built with Node.js and Express.js that streamlines hospital operations including appointment scheduling, patient management, billing, prescriptions, and real-time communication between doctors and patients.",
      image: "https://res.cloudinary.com/dnv6oqvjp/image/upload/c54cbdd9-8fa9-41b9-bc54-fa7748f90c66.png",
      technologies: [
        "Node.js",
        "Express.js",
        "MongoDB",
        "Mongoose",
        "JWT",
        "Passport.js",
        "Socket.io",
        "Razorpay",
        "Cloudinary",
        "Multer",
        "Twilio",
        "Nodemailer",
        "Swagger",
        "CORS",
        "bcrypt",
        "Moment.js"
      ],
      liveUrl: "https://nuxhealth-backend-dpti.onrender.com/api-docs/",
      githubUrl: "",
      featured: true
    },
    {
      id: 3,
      title: "Ghost Feedback System",
      description: "A secure, anonymous suggestion box system built with the MERN stack (MongoDB, Express.js, React, Node.js) that allows employees to submit feedback and suggestions without revealing their identity.",
      image: "https://res.cloudinary.com/dnv6oqvjp/image/upload/e0335e5a-8386-4c48-85a2-4643bb5ed03c.png",
      technologies: ["React", "Node.js", "Express", "MongoDB", "JWT", "Express-validator", "Helmet, CORS, Rate Limiting"],
      liveUrl: "https://ghost-feedbacksystem.vercel.app/",
      githubUrl: "https://github.com/DishantMadariya/ghost-feedbacksystem",
      featured: true
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-primary/10 text-primary rounded-full text-sm font-medium mb-6">
            <Icon name="Star" size={16} className="mr-2" />
            Featured Work
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6">
            Recent Projects
          </h2>
          
          <p className="text-lg text-text-secondary max-w-2xl mx-auto mb-8">
            Showcasing innovative solutions and technical expertise through real-world applications 
            that solve complex business challenges.
          </p>
        </div>
        
        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {projects.map((project) => (
            <div
              key={project.id}
              className="bg-surface rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-border"
            >
              {/* Project Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                
                {/* Live Demo Button */}
                <div className="absolute top-4 right-4">
                  <a
                    href={project.liveUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1 bg-primary text-white rounded-full text-sm font-medium hover:bg-primary/90 transition-colors"
                  >
                    <Icon name="ExternalLink" size={14} className="mr-1" />
                    Live Demo
                  </a>
                </div>
              </div>
              
              {/* Project Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-text-primary mb-3">{project.title}</h3>
                
                <p className="text-text-secondary mb-4 line-clamp-3">{project.description}</p>
                
                {/* Technologies */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {project.technologies.map((tech) => (
                    <span
                      key={tech}
                      className="px-3 py-1 bg-muted text-text-secondary text-sm rounded-full"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                
                {/* Action Buttons */}
                <div className="flex items-center justify-between">
                  <Link to={`/projects`}>
                    <Button variant="outline" size="sm" iconName="Eye" iconPosition="left" className="w-full sm:w-auto border-2 border-slate-300 dark:border-input">
                      View Details
                    </Button>
                  </Link>
                  
                  <a
                    href={project.githubUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-text-secondary hover:text-primary transition-colors"
                    title="View Source Code"
                  >
                    <Icon name="Github" size={20} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* CTA */}
        <div className="text-center">
          <Link to="/projects">
            <Button variant="default" size="lg" iconName="FolderOpen" iconPosition="left">
              View All Projects
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;